import React, { useState } from "react";
import { apiPut, apiGet, apiDelete } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { isEmpty } from "lodash";
import dayjs from "dayjs";
import useToastContext from "hooks/useToastContext";
import { AiFillEye, AiFillEdit, AiFillDelete } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import helper from "../../utils/helpers";
import TableHeaderCell from "components/reusable/TableHeaderCell";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../../components/reusable/ConfirmationModal";

const Table = ({
  allCompany,
  getCompany,
  handleUserView,
  handleUserPassword,
  user,
  page,
  sort,
  setSort,
  manager,
}) => {
  const { t } = useTranslation();
  const notification = useToastContext();
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    item: null,
  });
  const navigate = useNavigate();
  const [loadingStates, setLoadingStates] = useState({});

  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.changeCompanyStatus}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        getCompany();
      }
    } catch (error) {
      console.log("error in get all company list==>>>>", error.message);
    }
  };

  const handleCompany = async (item) => {
    try {
      const payload = {
        companyId: item._id,
      };
      const path = apiPath.companyList;
      const result = await apiGet(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        const refresh_token = result?.data?.results?.token || null;
        localStorage.getItem("token", refresh_token);
        localStorage.setItem("refresh_token", refresh_token);
        window.open(
          `${process.env.REACT_APP_COMPANY_URL}/login?token=${refresh_token}`
        );
      }
    } catch (error) {
      console.log("error in get all company list==>>>>", error.message);
    }
  };

  const handleEdit = (item) => {
    navigate("/company-manager/edit", { state: item });
  };

  const handleDelete = async (item) => {
    try {
      const path = `${apiPath.deleteCompany}/${item._id}`;

      const result = await apiDelete(path);

      if (result?.status === 200) {
        notification.success(t("CONTENT_DELETED_SUCCESS"));
        getCompany();
      } else {
        notification.error(result?.data?.message || t("DELETE_FAILED"));
      }
    } catch (error) {
      console.error("Delete error:", error);
      notification.error(error.message || t("DELETE_FAILED"));
    }
  };

  return (
    <div className="p-3">
      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        isOpen={deleteModal.isOpen}
        onClose={() => setDeleteModal({ isOpen: false, item: null })}
        onConfirm={() => handleDelete(deleteModal.item)}
        title={t("CONFIRM_DELETE")}
        message={t("ARE_YOU_SURE_DELETE_THIS_COMPANY", {
          title: deleteModal.item?.name,
        })}
        confirmText={t("DELETE")}
        cancelText={t("CANCEL")}
        isLoading={loadingStates.delete}
        isDanger={true}
      />
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <TableHeaderCell text={t("SR_NO")} />
              <TableHeaderCell text={t("COMPANY_ID")} />
              <TableHeaderCell text={t("COMPANY_NAME")} />
              <TableHeaderCell text={t("COMPANY_NUMBER")} />
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  if (
                    sort.sortBy === "officialEmail" &&
                    sort.sortType === "asc"
                  ) {
                    setSort({
                      sortBy: "officialEmail",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortBy: "officialEmail",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex justify-left">
                  <span>{t("OFFICIAL_EMAIL_ID")}</span>
                  <span>
                    {sort.sortBy === "officialEmail" &&
                      sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort.sortBy === "officialEmail" &&
                      sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  if (sort.sortBy === "createdAt" && sort.sortType === "asc") {
                    setSort({
                      sortBy: "createdAt",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortBy: "createdAt",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex justify-start">
                  <span>{t("CREATED_DATE")}</span>
                  <span>
                    {sort.sortBy === "createdAt" && sort.sortType === "asc" && (
                      <BsArrowUpShort className="w-4 h-4" />
                    )}
                    {sort.sortBy === "createdAt" &&
                      sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              <TableHeaderCell text={t("COUNTRY")} />
              <TableHeaderCell text={t("STATE")} />
              {(manager?.add || manager?.edit || user?.role === "admin") && (
                <th scope="col" className="py-3 px-6 text-center">
                  {t("O_STATUS")}
                </th>
              )}
              <th scope="col" className="py-3 px-6 text-center">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>
          <tbody>
            {allCompany &&
              allCompany?.map((item, i) => (
                <tr
                  key={i}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                >
                  <th
                    scope="row"
                    className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white"
                  >
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className="py-4 px-6 border-r text-gray-900">
                    {item?._id}{" "}
                  </td>
                  <td className="py-4 px-6 border-r text-blue-500">
                    {user.role === "admin" ? (
                      <a target="_blank" onClick={() => handleCompany(item)}>
                        {" "}
                        <span className="hover:underline hover:text-[#9D36FF] cursor-pointer">
                          {" "}
                          {item?.name}
                        </span>{" "}
                      </a>
                    ) : (
                      item?.name
                    )}
                  </td>
                  <td className="py-4 px-6 border-r text-left text-gray-900">
                    {item?.companyNumber}
                  </td>
                  <td className="py-4 px-6 border-r text-left text-gray-900">
                    {item?.officialEmail}
                  </td>
                  <td className="py-4 px-6 border-r text-left text-gray-900">
                    {dayjs(item?.createdAt).format("MM-DD-YYYY hh:mm A")}{" "}
                  </td>
                  <td className="py-4 px-6 border-r text-left text-gray-900">
                    {item?.Country?.name}
                  </td>
                  <td className="py-4 px-6 border-r text-left text-gray-900">
                    {item?.State?.name}
                  </td>
                  {(manager?.add ||
                    manager?.edit ||
                    user?.role === "admin") && (
                    <td className="py-4 px-6 border-r text-center text-gray-900">
                      <label
                        className="inline-flex relative items-center cursor-pointer"
                        title={`${
                          item?.status === "active" ? "Active" : "Inactive"
                        }`}
                      >
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={item?.status === "active"}
                          onChange={(e) =>
                            helper.alertFunction(
                              `Are you sure you want to ${
                                e.target.checked ? "active" : "inactive"
                              } '${item.name} '?`,
                              item,
                              handelStatusChange
                            )
                          }
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                      </label>
                    </td>
                  )}
                  <td className="py-4 px-6 border-l text-gray-900">
                    <div className="">
                      <ul className="flex justify-center">
                        {(manager?.view || user?.role === "admin") && (
                          <li
                            onClick={() => handleUserView(item)}
                            className="px-2 py-2 hover:bg-white hover:text-LightBlue"
                          >
                            <a title={t("O_VIEW_USER")}>
                              {" "}
                              <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                            </a>
                          </li>
                        )}
                        {(user?.role === "admin" || manager?.edit) && (
                          <button
                            onClick={() => handleEdit(item)}
                            title={t("EDIT")}
                            className="px-2 py-2 text-slate-600 hover:text-indigo-700 transition duration-150"
                          >
                            <AiFillEdit className="w-5 h-5" />
                          </button>
                        )}
                        {(user?.role === "admin" || manager?.delete) && (
                          <button
                            onClick={() => {
                              if (!item?._id) {
                                notification.error("Invalid content ID");
                                return;
                              }
                              setDeleteModal({
                                isOpen: true,
                                item: item,
                              });
                            }}
                            title={t("DELETE")}
                            className="px-2 py-2 text-slate-600 hover:text-red-600 transition duration-150"
                          >
                            <AiFillDelete className="w-5 h-5" />
                          </button>
                        )}
                        {user?.role === "admin" && (
                          <li
                            onClick={() => handleUserPassword(item)}
                            className="px-2 py-2 hover:bg-white hover:text-LightBlue"
                          >
                            <a
                              title={t("CHANGE_PASSWORD")}
                              className="cursor-pointer"
                            >
                              <img
                                src="./images/password.png"
                                className="max-h-[18px]"
                                alt="password"
                              />
                            </a>
                          </li>
                        )}
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(allCompany) ? (
              <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={12}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
